import { IAddNewUsersInitialState } from "./AddNewUsers.context";

import { UPDATE_EMAIL_LIST, HAS_SELECTED_PERMISSION } from "./AddNewUsers.actions";

const Reducer = (
    state: IAddNewUsersInitialState, 
    action: { type: string, payload: any }
) => {
        switch (action.type) {
            case UPDATE_EMAIL_LIST:
                return {
                  ...state,
                  email_list: action.payload,
                };
            case HAS_SELECTED_PERMISSION:
                return {
                  ...state,
                  hasSelectedPermission: action.payload,
                };
                default:
                    return state;
        }
}

export default Reducer;